import { isSecretMenuModalShownAtom } from '@/components/Modals/atom';
import { useEffect } from 'react';
import { useSetAtom } from 'jotai';

// Listen for keyboard shortcut to open modal (Ctrl/Cmd + /)
export const useSecretMenuShortcut = () => {
    const setIsModalOpen = useSetAtom(isSecretMenuModalShownAtom);

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === '/') {
                event.preventDefault();
                setIsModalOpen((prev) => !prev);
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [setIsModalOpen]);
};
